import { render, staticRenderFns } from "./StatisticCardVerticalRecognitions.vue?vue&type=template&id=147b7bfa&"
import script from "./StatisticCardVerticalRecognitions.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalRecognitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports